import React from "react";
import CheckoutButton from "components/checkout-button";
import CartSummary from "./summary";

const CartFooter = ({ isSticky }) => (
	<div className="z-10 px-7 pb-3 bg-white">
		<CartSummary isSticky={isSticky} />
		<div className="lg:mx-2">
			<CheckoutButton />
		</div>
	</div >
);

export default CartFooter;